// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1OFLw","errors":"Errors_errors__1zNaY"};